export const GOODS = {
    YAKULT: '益力多',
    YAKULT_DT: '益力多低糖',
    YAKULT_SUGAR_FREE: '益力多500亿0蔗糖',
    YAKULT_PEACH: '益力多水蜜桃味',
    YAKULT_TEN: '益力多原味10支装',
    YAKULT_GRAPE: '益力多青提味',
    YAKULT_TWENTY_GRAPE: '益力多青提味20支装',
    YAKULT_ABBREVIATION: "（原味）",
    YAKULT_DT_ABBREVIATION: "（低糖）",
    YAKULT_SUGAR_FREE_ABBREVIATION: "（500亿0蔗糖）",
    YAKULT_PEACH_ABBREVIATION: "（水蜜桃味）",
    YAKULT_GRAPE_ABBREVIATION: "（青提味）",
    YAKULT_TEN_ABBREVIATION: "（原味）10支",
    YAKULT_TWENTY_GRAPE_ABBREVIATION: "（青提味）20支",
    YAKULT_TWENTY_ABBREVIATION: "（原味）20支",
    YAKULT_TWENTY_DT_ABBREVIATION: "（低糖）20支",
    YAKULT_MANGO_ABBREVIATION: "（芒果味）",
    YAKULT_TEN_DT_ABBREVIATION: "（低糖）10支",
}